export default __webpack_public_path__ + "static/media/background3.61505295.jpeg";